<script lang="ts"></script>

<style lang="scss" global>
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
</style>
